/* @flow */
import { Record, List } from 'immutable';

export type Permission =
    'use_station'
    | 'manage_company_users'
    | 'manage_marketplace_subscription'
    | 'manage_stash'
    | 'manage_redaction_library'
    | 'manage_enclaves'
    | 'manage_templates'
    | 'manage_companies'
    | 'get_enclaves'
    | 'get_companies'
    | 'get_data'
    | 'manage_malware'
    | 'manage_threat_actors'
    | 'manage_whitelist'
    | 'manage_sharing_groups'
    | 'grant_internal_roles'
    | 'communicate_with_all_users'
    | 'administer_marketplace'
    | 'manage_feeds'
    | 'god';

export type RawRole = {
  internal: boolean,
  name: String,
  displayName: String,
  permissions: List<Permission>,
};

export const Role = Record({
  internal: null,
  name: '',
  displayName: '',
  permissions: List(),
});



// WEBPACK FOOTER //
// ./src/app/modules/roles/types.js